import { render, staticRenderFns } from "./CommissionSettings.vue?vue&type=template&id=44497342"
import script from "./CommissionSettings.vue?vue&type=script&lang=js"
export * from "./CommissionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports